export default __webpack_public_path__ + "static/media/array.16425f90.svg";